import React, { Component } from 'react';
import { connect } from 'react-redux';
import { clickNode, loginUser } from '../../actions';
import { TextField, RaisedButton } from 'material-ui'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import locale from '../../common/locale'
import { Link } from "react-router-dom";
import Cookies from 'universal-cookie';
const cookies = new Cookies();
const Spinner = require('react-spinkit');

export class EmailLogin extends Component {

  constructor(props) {
    super(props);
    this.state = { loading: false, errors: {} }
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(data) {
    data.preventDefault();
    const loc = cookies.get('locale')
    if(!validateEmail(this.refs.email.getValue())) {
      this.setState({ loading: false, errors: { email: locale.is_invalid(loc) } })
      return
    }
    if(this.refs.password.getValue().length < 6) {
      this.setState({ loading: false, errors: { password: locale.is_invalid(loc) } })
      return
    }
    this.setState({ loading: true, errors: {} })
    this.props.loginUser(this.refs.email.getValue(), this.refs.password.getValue(), loc)
  }

  render() {
    const loc = cookies.get('locale')
    const errors = Object.assign(this.props.server.errors, this.state.errors)

    if(this.state.loading && Object.keys(errors).length === 0) {
      return(
        <div style={{transform: `translate3d(75px, 75px, 0px)`}} >
          <section>loading...</section>
          <Spinner name="line-scale-pulse-out-rapid" />
        </div>
      )
    }

    return(
      <MuiThemeProvider>
        <i className="fas fa-envelope fa-5x" />
        <form onSubmit={this.handleSubmit}>
          <p>{locale.login_with_email(loc)}</p>
          <TextField floatingLabelText={locale.email(loc)} ref="email"
            floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
            errorText={errors['email']}
            underlineFocusStyle={styles.underlineStyle} />
          <p />
          <TextField
            floatingLabelText={locale.password(loc)}
            ref="password"
            errorText={errors['password']}
            floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
            underlineFocusStyle={styles.underlineStyle} />
          <p />
          <RaisedButton label={locale.login(loc)} type="submit" />
          <ul className="signup">
            <li><Link to="/users/forgot">{locale.forgotYourPW(loc)}</Link></li>
            <li><Link to="/signup">{locale.sign_up(loc)}</Link></li>
          </ul>
        </form>
      </MuiThemeProvider>
    )
  }
}

const validateEmail = email => {
  return /\S+@\S+\.\S+/.test(email);
}

const styles = {
  floatingLabelFocusStyle: {
    color: "#000000"
  },
  underlineStyle: {
    borderColor: '#000'
  }
}

const mapDispatchToProps = {
  clickNode,
  loginUser
}

const mapStateToProps = state => ({
  server: state.server,
});

export default connect(mapStateToProps, mapDispatchToProps)(EmailLogin);



// WEBPACK FOOTER //
// ./src/components/SignupLogin/EmailLogin.js